import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Work from "@/pages/Work";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TikTokServices from "@/pages/TikTokServices";
import FreeWebsite from "@/pages/FreeWebsite";
import WebsiteTerms from "@/pages/WebsiteTerms";

// Service Pages
import Design from "@/pages/services/Design";
import Web from "@/pages/services/Web";
import LiveChat from "@/pages/services/LiveChat";
import SocialMarketing from "@/pages/services/SocialMarketing";
import DigitalMarketing from "@/pages/services/DigitalMarketing";
import AIServices from "@/pages/services/AIServices";
import LearnSkills from "@/pages/services/LearnSkills";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col bg-black">
        <BrowserRouter>
          <Navigation />
          <main className="flex-1">
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/work" element={<Work />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tiktok-services" element={<TikTokServices />} />
            <Route path="/free-website" element={<FreeWebsite />} />
            <Route path="/website-terms" element={<WebsiteTerms />} />
            <Route path="/services/design" element={<Design />} />
            <Route path="/services/web" element={<Web />} />
            <Route path="/services/live-chat" element={<LiveChat />} />
            <Route path="/services/social-marketing" element={<SocialMarketing />} />
            <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/services/ai-services" element={<AIServices />} />
            <Route path="/services/learn-skills" element={<LearnSkills />} />
          </Routes>
          </main>
          <Footer />
          <CookieBanner />
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
